import React from 'react';
import { observer, inject } from "mobx-react";
import {Link, Switch, Redirect } from 'react-router-dom';
import { Input, InputFile, SelectInput, Collapsible, DatePicker, InputValidation, Table, Chips, Accordion, Spinner, Pagination ,Tabs , Modal } from '@sogei/react-web-components-catalog'
import { breadcrumbRicevutePegno, breadcrumbRicevutePegnoSecondoLivello, breadcrumbTrasmissionePegno } from '../../assets/breadcrumb';
import i18next from 'i18next';
import { Formik } from 'formik';
import * as Yup from 'yup'
import { AppButton } from '../commons/button';
import { decodeTipologica, scrollToTop } from '../commons/uiUtils';
import { regExpDate, regExpOnlyNumbers } from '../../assets/utils/regexp';
import { tableHeadUnico, tableHeadUnicoTerzoLivelloCons,tableHeadUnicoTerzoLivelloCat,tableHeadUnicoTerzoLivelloConsNoTitoloDigitale } from '../../assets/tableHeaders';
import { element } from 'prop-types';
import { RicevutaFirmataENon } from '../ricevute/ricevutaFirmataENon';
import { DownloadDocumento } from '../ricevute/downloadDocumento';


@inject("rootStore")
@observer
class DettaglioII extends React.Component {

    constructor(props) {
        super(props);
        this.tipologicaStore = props.rootStore.tipologicaStore;
        this.ricevuteStore = props.rootStore.ricevuteStore;
        this.qualificheStore = props.rootStore.qualificheStore;
        this.tipoPratica = this.qualificheStore.tipoPratica;
    }  

    componentDidMount() {}


    componentWillUnmount() {}

  

    render() {    

      const dettaglioTerzoLivello = this.ricevuteStore.dettaglioTerzoLivello;
      

      const statoPraticaRisultato = this.ricevuteStore.statoPraticaRisultato;
      const tableHeadConservatorie= (dettaglioTerzoLivello.ricevuta.titoloDigitale !== '1')?tableHeadUnicoTerzoLivelloConsNoTitoloDigitale:tableHeadUnicoTerzoLivelloCons
      
      const numEsitiConservatoria =  dettaglioTerzoLivello.esitiTerzoLivello.filter(elemento => ['CO'].some(x => x === elemento.tipoUfficio)).length
      const numEsitiCatasto = dettaglioTerzoLivello.esitiTerzoLivello.filter(elemento => ['CA'].some(x => x === elemento.tipoUfficio)).length
     


      const tableHead = (tableHeader)=>{
        //console.log(tableHeader)
        let thLivello1 = tableHeader.filter(x => x.livello==1 ).map( cellaHeader => {
          const cella = <th style={{verticalAlign:"middle"}} className= {cellaHeader.classNameHeader}  colSpan={cellaHeader.colSpan} rowSpan={cellaHeader.rowSpan}> {i18next.t(cellaHeader.label)} </th>
          return cella;
        })
  
        let thLivello2 = tableHeader.filter(y => y.livello==2 ).map( cellaHeader => {
          const cella = <th style={{verticalAlign:"middle"}} className= {cellaHeader.classNameHeader}  colSpan={cellaHeader.colSpan} rowSpan={cellaHeader.rowSpan}> {i18next.t(cellaHeader.label)} </th>
          return cella;
        })
        
        let output = 
        <>
          <tr> {thLivello1}
        </tr>
        <tr> {thLivello2}
        </tr>
      
        </>
        return output;
    }
  
    const documentIcon = (border, icon, iconStyle, spanSrOnly, onClick,titolo) => {
      let customClass = 'btn btn-light border ' + border;
      let iconCenter = icon + ' ' + iconStyle;
      return <AppButton color="none" spanSrOnly={i18next.t(spanSrOnly)} customClass={customClass} iconCenter={iconCenter} type="button"  onClick={onClick} titleKey='' extraProps={{title:i18next.t(titolo)}}/>
    }
    const dettaglioButton = (item) =>{
      if((item.statoPratica == '11' || item.statoPratica == '22'))
        return <AppButton spanSrOnly="BUTTON_VAI_A_DETTAGLIO" color="outlined-blu" type="button" iconCenter="fas fa-eye" onClick={() => this.navigateToDettaglio(item)} titleKey=''/>
      else
        return undefined
    }
    

    const restituzioneDiParte = (item,element) =>{
     let output = ' - '
      if(item.dataRestituzioneNote){
        output= item.descRestituzioneFormalita
     }
     else if(item.esitoCons==='0'){
      output = <AppButton  color="warning"
      
     iconLeft="fas fa-circle-exclamation mr-2"
     titleKey={i18next.t("BUTTON_RICHIEDI")}
     params
     disabled ={this.ricevuteStore.restituzioneDiParteGiaRichiesta}
     onClick={() =>{
      var msg = "Si sta richiedendo la Restituzione delle note, relative al repertorio " + dettaglioTerzoLivello.ricevuta.primoNumeroRepertorio +"/"+ dettaglioTerzoLivello.ricevuta.secondoNumeroRepertorio + ", depositate presso l'" + item.denomUfficio +" ; ciò comporta la 'Rinuncia alla Trascrizione' di tali formalità. Si conferma la richiesta?";
			if(confirm(msg)){
       let params = {}
       
       params.idPratica = dettaglioTerzoLivello.ricevuta.idPratica,
       params.codUfficio = item.codUfficio
       params.primoNumeroRepertorio = dettaglioTerzoLivello.ricevuta.primoNumeroRepertorio
       params.secondoNumeroRepertorio = dettaglioTerzoLivello.ricevuta.secondoNumeroRepertorio
       params.dataPresentazione = dettaglioTerzoLivello.ricevuta.timestampInvio.split(" ")[0]
       params.progrNotaDisp= item.progrNotaDisp
       this.ricevuteStore.restituzioneDiParte(params)
      }
      else{}
      
    }
    }></AppButton> 
  

  }
      return output

    }
    const pagamentoIntegrativo = (item,element) => {
      if (item.idPagamentoP7m || item.idPagamentoPdf){
        //console.log("ciao")
       return <RicevutaFirmataENon item= {item} element= {element}/>
      }
      else{
        //console.log("ciaone")
      return (<AppButton  color="success"
      
      iconLeft="fas fa-pen mr-2"
      titleKey="COMPILA"
      params
      onClick={() =>{
        let params = {}
        params.codiceAtto = item.codiceAtto 
        this.ricevuteStore.fetchDatiPagamentoIntegrativoPrecompilato(params)}}></AppButton>) }
    }
    const downloadButton = (item,element )=> {
      if(
        (!item.condizione?true:item[element.nomeKeyServizio]==item.condizione) && item[element.file]){
          let downloadParam
          if( item[element.file] instanceof Object ){
            downloadParam = {fileMetaData: item[element.file]};
            
          }
          else{
            downloadParam = {idFile: item[element.file]};
            
          }
  
      return documentIcon(
        element.warning?
          item[element.nomeKeyServizio] == element.warning ? 'border-warning' : 'border-danger'
          :
          'border-info',
          element.icon,
          element.warning?
          item[element.nomeKeyServizio] == element.warning ? 'icon-warning' : 'icon-danger'
          :
          'icon-info',
          element.spanSrOnly,
          () => {this.ricevuteStore.downloadFile(downloadParam)},
          '')
        }
        else return undefined
  
  
  
  
  
      
    }
    
const servizioStatoPratica = (item) =>  {
      
        let colonnaStato;

        if(item.stato==2&&item.esito==2) {
          colonnaStato =  <>
          <Modal labelId="label" containerId="containerIdMotivoRifiuto" title="Motivazione scarto" body={
                <p>
                    {item.motivoRifiuto}
                </p>
                }>
            {" "}
          </Modal>           
          <button type="button" className="btn btn-light border border-danger" data-toggle="modal" data-target="#containerIdMotivoRifiuto">
                {item.descStatoElaborazione}
          </button>             
          </> 
        }
        else if((item.stato==2&&item.esito==3&&!item.duplo)||(item.stato==1&&item.esito==0&&!item.duplo)) {
          colonnaStato =  <>
          <Modal labelId="label" containerId="containerIdStatoPratica" title="Stato pratica" body={
                <p>
                  {statoPraticaRisultato === undefined ? "" : statoPraticaRisultato.esito != 0 ? "Servizio di recupero dello stato non disponibile, si prega di riprovare più tardi." : "Domanda del pegno depositata presso l'ufficio in data: "} <b>{statoPraticaRisultato === undefined ? "" : statoPraticaRisultato.dataRicezione} {statoPraticaRisultato === undefined ? "" : statoPraticaRisultato.statoLavorazione == 1 ? ", in lavorazione" : ""}</b>
                </p>
                }>
            {" "}
          </Modal>           
          <button type="button" className="btn btn-light border" data-toggle="modal" data-target="#containerIdStatoPratica"  onClick={() => this.ricevuteStore.chiamataStatoPratica(item)}>
                {item.descStatoElaborazione}
          </button>             
          </> 
        }
        else {
          colonnaStato= item.descStatoElaborazione;
        }
        return colonnaStato;
      }

  const tableBody = (tableHeader,tipoUfficio) =>
  
  {

    
    if(dettaglioTerzoLivello === undefined || dettaglioTerzoLivello == 0)
     return (<tr><td colSpan="10" key={dettaglioTerzoLivello.length}><span>{i18next.t("TABLE_NO_RESULTS")}</span></td></tr>)
    else
   {
     
   const output=  dettaglioTerzoLivello.esitiTerzoLivello.filter(elemento => tipoUfficio.some(x => x === elemento.tipoUfficio)).map((item,index) => { return (
      <tr key={'result_'+item.idPratica+'_'+index}>
       {tableHeader.filter(z => z.type!=='td-none').map(element => {
        item.protocolloUfficio = item.protocollo + '/' + item.annoProtocollo
        item.repertorioRaccolta = item.primoNumRep + '/' + item.secondoNumRep
        item.registrazione = (item.dataRegistrazione||item.serieRegistrazione||item.numeroRegistrazione||item.sottoNumeroRegistrazione)?(item.dataRegistrazione?item.dataRegistrazione:'' + " Serie=" + item.serieRegistrazione + "Numero=" + item.numeroRegistrazione +",Sottonumero="+ item.sottoNumeroRegistrazione):'' ;
       
        return <td className={element.classNameCella}>{
          element.type==='text'?item[element.nomeKeyServizio]
          :
          element.type==='dettaglio'? dettaglioButton(item)
          :
          element.type==='ricevutaFirmataENon'? <RicevutaFirmataENon item= {item} element= {element}/>
          :
          element.type==='downloadDocumento'? <DownloadDocumento item={item} element = {element}></DownloadDocumento>
          :
          element.type==='servizioStatoPratica'? servizioStatoPratica(item)
          :
          element.type==='pagamentoIntegrativo'? pagamentoIntegrativo(item,element) 
          :
          element.type='restituzioneDiParte'? restituzioneDiParte(item,element)
          :
          undefined}
          </td>
        
       })
       } 
      </tr>
  )
  })
  return output;

  
  }

  }

 



  const  tabsItems =  []

    numEsitiConservatoria?
    tabsItems.push(
      {
    title: <><p>Pubblicità Immobiliare  <span className="badge badge-primary"> {numEsitiConservatoria} </span> </p> </> ,
    titleHeading: "h1",
    body : <Table tableHead={tableHead(tableHeadConservatorie)}tableBody={tableBody(tableHeadConservatorie,['CO'])} tableOptions={['table-header']}/>
    }):undefined
    
    numEsitiCatasto?tabsItems.push(
      {
      title: <><p>Catasto  <span className="badge badge-primary"> {numEsitiCatasto} </span> </p> </> ,
      titleHeading: "h1",
      body : <Table tableHead={tableHead(tableHeadUnicoTerzoLivelloCat)} tableBody={tableBody(tableHeadUnicoTerzoLivelloCat,['CA'])} tableOptions={['table-header']}/>
      }
      )
      :undefined
           
    

  
  

        return (
          <div className="container-fluid pr-3 pl-3 pb-3">
            
              <div className="row">              
                <div className="col">
                  <h3>{i18next.t("ELENCO_FORMALITA")}</h3>
                  <div className='my-4'>
                    <AppButton 
                      color="none"
                      isLinkStyle={true}
                      iconLeft="fas fa-long-arrow-alt-left mr-2"
                      titleKey="BUTTON_TORNA_ELENCO_ADEMPIMENTI"
                      onClick={() => this.ricevuteStore.backToSecondoLivello(this.tipoPratica)}
                    />
                  </div>
                  {dettaglioTerzoLivello && (/*<>
                    <div className='row'>
                      <div className='col'>
                        <p>
                          <strong>{i18next.t("DETTAGLIO_CODICE_INVIO", dettaglioTerzoLivello.ricevuta)}</strong>
                          {dettaglioTerzoLivello.avvisoPagamento.length > 0 ? (<><br/><strong>{i18next.t("DETTAGLIO_DOMANDA",dettaglioTerzoLivello.avvisoPagamento[0])}</strong></>) : ''}
                          {dettaglioTerzoLivello.ricevuta.serieRegistrazione ? (<><br/><strong>{i18next.t("DETTAGLIO_SERIE",dettaglioTerzoLivello.ricevuta)}</strong></>) : ''}
                        </p>
                        <p></p>
                      </div>
                    </div>*/<>
                    <div className='row mt-3'>
                      <div className='col'>
                              <Tabs
                                  items={
                                    tabsItems
                                  }
                                  isReverseType={true}
                                  onShow={(e) => console.log(e)}
                              >
                                  {" "}
                             </Tabs>
                        
                      </div>
                    </div>
                  </>)}
                </div>
              </div>
            
          </div>
        ); 
      }
}


export default DettaglioII

export { DettaglioII }

